import { CbhFeatureFlag, FEATURE_FLAG_DEFAULT_VALUES, useCbhFlag } from "../FeatureFlags";

export function useLiveActivitiesConfig() {
  return useCbhFlag(CbhFeatureFlag.LIVE_ACTIVITIES_CONFIG, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.LIVE_ACTIVITIES_CONFIG],
  });
}
